/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    standalone: false
})
export class ItemComponent implements OnInit {
    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }
    get disabled(): boolean | '' {
        return this._disabled;
    }
    @Input() detailIcon = true;
    @Input() icon = '';
    @Input() iconColor = '';
    @Input() lines: string;
    @Input() multiline = false;
    @Input() endIcon = 'chevron-forward-outline';

    private _disabled: boolean;

    constructor() {
    }

    ngOnInit(): void {
    }

}
